import AfterDoc from '@/components/ui/AfterDoc';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const ThankYouNotQualifyForeignIssuer = () => {
  const { i18n } = useLingui();

  return (
    <AfterDoc
      consultant={CONSULTANTS.EWELINA_ASSISTANT}
      thankYouMessage={i18n.t(
        'Niestety nie możemy zaoferować obsługi Twojej sprawy'
      )}
      withButton
    >
      <>
        <span>
          {i18n.t(
            'Zgodnie z obowiązującymi przepisami jesteśmy zobligowani do prowadzenia procesu zgodnie z prawem obowiązującym w kraju, w którym miało miejsce zdarzenie.'
          )}
        </span>
        <span>
          {i18n.t(
            'W związku z powyższym nie jesteśmy w stanie kontynuować weryfikacji Twojej sprawy, jeśli szkoda wydarzyła się poza granicami Polski.'
          )}
        </span>
        <span className="font-semibold">
          {i18n.t(
            'Dziękujemy za zrozumienie i w przypadku pytań zapraszamy do kontaktu.'
          )}
        </span>
      </>
    </AfterDoc>
  );
};

export default ThankYouNotQualifyForeignIssuer;
